<template>
    <div id="header">
        <img src="../img/head.png" width="100%" alt="">
        <span v-if="maptext != undefined">{{maptext}}&nbsp;&nbsp;{{nowTime}}</span>
        <span v-else>数据更新时间&nbsp;&nbsp;{{nowTime}}</span>
        <div id="nowtime">{{nowDate}} {{nowTime}} {{nowWeek}}</div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data(){
        return{
            showHide: 0,
            count: 10,
            nowDate: '',
            nowTime: '',
            nowWeek: '',
            maptext: '',
            Time: ''
        }
    },
    watch: {

    },
    mounted () {
        this.currentTime()
        // this.clickTimex()
        this.setTime();
    },
    methods: {

        currentTime() {
            setInterval(this.formatDate, 500);
        },
        clickTimex(){
            this.timer = setInterval(() => {
                this.setTime();
            }, 10000)
        },
        setTime(){
            var _this = this
            // setTimeout(val=>{
                if(_this.$route.query.map != 'undefined' || _this.$route.query.map != ''){
                    _this.maptext = this.$route.query.map
                }else{
                    _this.maptext = ''
                }
                console.log(_this.maptext,"参数")
            // }, 500)
        },
        formatDate() {
            //获取当前时间并打印
            let myDate = new Date()
            let wk = myDate.getDay()
            let yy = String(myDate.getFullYear())
            let mm = myDate.getMonth() + 1
            let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
            let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
            let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
            let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
            let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
            let week = weeks[wk]
            this.nowDate = yy + ' 年 ' + mm + ' 月 ' + dd + ' 日'
            this.nowTime = hou + ':' + min + ':' + sec
            this.Time = hou + ':' + min
            this.nowWeek = week
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue